// Match the first photo before product hydration, including configuration deep links.
(() => {
  window.FloydInitialGallery ||= {}
  document.querySelectorAll('[data-product-gallery-catalog]').forEach((element) => {
    const catalog = JSON.parse(element.textContent)
    const query = new URLSearchParams(location.search)
    const variant = catalog.variants.find(({ id }) => `${id}` === query.get('variant'))
      ?? catalog.variants.find(({ id }) => id === catalog.selectedVariant)
      ?? catalog.variants[0]
    if (!variant) return
    const configuration = catalog.configurations.includes(query.get('configuration'))
      ? query.get('configuration') : catalog.configurations[0]
    const filtered = Shopify.ImagesByVariant(catalog.images, catalog, variant,
      configuration ? { id: configuration } : null)
    const primary = filtered.find(image => image.attachedToVariant && image.variantsIds.includes(variant.id))
      ?? filtered[0] ?? catalog.images[0]
    if (!primary) return
    const renderingKeys = ['tag', ...catalog.options.flatMap(({ name }) => [name, Shopify.slugify(name, '_')])]
    const images = filtered.filter(image => image.attachedToVariant || image.src === primary.src
      || (/^featured(?:\s*,|$)/i.test(image.alt?.trim() ?? '')
        && Shopify.ImageAltData(image.alt, catalog.options).objects.some(data => renderingKeys.some(key => !!data[key]))))
    window.FloydInitialGallery[catalog.id] = images.length ? images : [primary]
    const image = element.closest('.product-gallery').querySelector('[data-product-primary-image]')
    if (!image) return
    image.sizes = Shopify.ProductImageSizes(primary, images.length > 1,
      element.closest('.product-gallery').dataset.showThumbnails === 'true')
    image.srcset = Shopify.ImageSrcset(primary.src)
    image.src = Shopify.Image(primary.src, 1080)
    image.alt = primary.alt ?? catalog.title
    image.width = primary.width
    image.height = primary.height
  })
})()
